import { createDiscreteApi } from "naive-ui/es/discrete";
import { t } from "./i18n";

let messageApi: ReturnType<typeof createDiscreteApi>["message"] | null = null;
let styleInjected = false;

function ensureToastStyle() {
	if (!import.meta.client || styleInjected) return;
	styleInjected = true;
	const style = document.createElement("style");
	style.id = "seer-pc-add-bazi-toast-style";
	style.textContent = `
		.n-message.seer-pc-add-bazi-toast {
			padding: 16px 28px !important;
			border-radius: 12px !important;
			min-height: 52px;
			align-items: center;
		}
		.n-message.seer-pc-add-bazi-toast .n-message__icon {
			font-size: 22px !important;
			margin-right: 10px !important;
		}
		.n-message.seer-pc-add-bazi-toast .n-message__content {
			font-size: 18px !important;
			line-height: 26px !important;
			font-weight: 600;
		}
	`;
	document.head.appendChild(style);
}

function getMessageApi() {
	if (!messageApi) {
		const api = createDiscreteApi(["message"], {
			messageProviderProps: {
				placement: "top",
				containerStyle: "margin-top: 400px;",
			},
		});
		messageApi = api.message;
	}
	return messageApi;
}

/** PC：加大、偏下的「请添加档案」toast */
export function showAddBaziFileToast() {
	ensureToastStyle();
	getMessageApi()?.warning(t("请添加档案"), {
		duration: 2500,
		class: "seer-pc-add-bazi-toast",
	});
}
